import React from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import { PLATFORM } from '../../config/platform';
import './release.css';

export default function AppStoreButtons({ compact = false, source = 'website' }) {
  const appendSource = (url, platform) => {
    try {
      const parsed = new URL(url);
      if (platform === 'android') parsed.searchParams.set('referrer', `utm_source=${source}&utm_medium=web&utm_campaign=official_apps`);
      if (platform === 'ios') parsed.searchParams.set('ct', `${source}_official_apps`);
      return parsed.toString();
    } catch {
      return url;
    }
  };

  return (
    <div className={compact ? 'p4r-store-row compact' : 'p4r-store-row'}>
      <a href={appendSource(PLATFORM.ios.url, 'ios')} target="_blank" rel="noopener noreferrer" aria-label="Download Pool 4 Real on the App Store">
        <FaApple />
        <span><small>Download on the</small><strong>App Store</strong></span>
      </a>
      <a href={appendSource(PLATFORM.android.url, 'android')} target="_blank" rel="noopener noreferrer" aria-label="Get Pool 4 Real on Google Play">
        <FaGooglePlay />
        <span><small>Get it on</small><strong>Google Play</strong></span>
      </a>
    </div>
  );
}
